import PropTypes from 'prop-types';
import React from 'react';
import { IoIosArrowRoundForward as ArrowRighIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  icon: {
    color: '#ffae49',
    fontSize: 22,
    verticalAlign: 'middle',
  },
});

const RideTooltipArrowRightFooterComponent = React.memo(({ primaryProps }) => {
  const classes = useStyles();
  return (
    <button type="button" {...primaryProps}>
      <ArrowRighIcon className={classes.icon} />
    </button>
  );
});

RideTooltipArrowRightFooterComponent.propTypes = {
  primaryProps: PropTypes.shape().isRequired,
};

RideTooltipArrowRightFooterComponent.displayName =
  'RideTooltipArrowRightFooterComponent';

export default RideTooltipArrowRightFooterComponent;
